import React from 'react';
import { makeStyles } from '@mui/styles';
import Link from '@Common/components/Link';
import { useSelector } from 'react-redux';
import { RootState } from 'src/_common/models/redux/store';
import { AppBar, Grid, Theme, Toolbar } from '@quillbot/design-system';

import QuillLogo from './HeaderLogo';

import AccountMenu from './AccountMenu';

const useStyles = makeStyles<Theme>((theme) => ({
  offset: theme.mixins.toolbar,
  headerToolbar: {
    minHeight: '52px',
    [theme.breakpoints.down('lg')]: {
      minHeight: '45px',
    },
  },
  headerActions: {
    justifyContent: 'flex-end',
  },
  quillHeader: {
    borderBottom: '1px solid',
    color: theme.palette.divider,
  },

  extensionSidebar: {
    display: 'none !important',
    [theme.breakpoints.down('lg')]: {
      display: 'flex',
    },
  },
  premiumTitle: {
    fontSize: '0.75em',
    letterSpacing: '1px',
    // color: '#D29E00',
    color: theme.palette.secondary.main,
    fontWeight: 600,
    marginTop: '10px',
    display: 'flex',
    alignSelf: 'flex-end',
    marginLeft: '5px',
    fontFamily: 'Open Sans',
    position: 'relative',
    top: '-5px',
  },
  /* new css code */
  quillLogo: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginRight: '18px',
    // '& svg': {
    //   // height: '35px',
    // },
    [theme.breakpoints.up(1600)]: {
      marginLeft: 6,
    },

    [theme.breakpoints.down(900)]: {
      minHeight: '48px',
      marginRight: '22px',
    },

    [theme.breakpoints.down(600)]: {
      marginLeft: '10px',
      marginRight: '10px',
    },
  },
}));

function MinHeader() {
  const userState = useSelector((rootState: RootState) => rootState.user);
  const platform = useSelector((rootState: RootState) => rootState.common.platform);
  const classes = useStyles({});

  const renderQuillBot = () => (
    <Link href="/">
      <a className={classes.quillLogo}>
        <div style={{ display: 'flex' }}>
          <QuillLogo />
          {userState?.premium ? <div className={classes.premiumTitle}>PREMIUM</div> : null}
        </div>
      </a>
    </Link>
  );

  const isExtension = platform.isExtension === true;

  return (
    <>
      {!isExtension && (
        <AppBar position="relative" elevation={1} color="inherit" className={classes.quillHeader}>
          <Grid container justifyContent="space-between">
            <Grid item flex={1} justifyContent="flex-start">
              <Toolbar
                className={classes.headerToolbar}
                style={{ paddingRight: 0, paddingLeft: 5 }}
              >
                {renderQuillBot()}
              </Toolbar>
            </Grid>
            <Grid item flex={1} justifyContent="flex-end">
              <Toolbar
                style={{ paddingLeft: 0 }}
                className={`${classes.headerToolbar} ${classes.headerActions}`}
              >
                <AccountMenu />
              </Toolbar>
            </Grid>
          </Grid>
        </AppBar>
      )}
    </>
  );
}

export default MinHeader;
